export default __webpack_public_path__ + "static/media/32-membrane.6d58f96f.png";